import React from "react";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, Bullets } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Build on Your Lot", path: "/build-on-your-lot" }];

const BuildOnYourLot = () => (
  <>
    <Seo
      title="Build on Your Lot in Central Florida | Build Highland Homes"
      description="Build a custom home on your own land in Central Florida. Build Highland Homes builds on your lot — with a property-specific evaluation of access, utilities, drainage, and setbacks."
      path="/build-on-your-lot"
      keywords="build on your lot, custom home builder on your lot, build a custom home on my land, custom home on private property"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="Build on Your Lot" title="Build a Custom Home on Your Land" subtitle="Every Build Highland Homes home is built on your lot or property. Whether you already own land or are evaluating a parcel, we design and build a home that fits your site." image={IMAGES.steelAerial1} />

    <Section className="bg-[#0b0b0b]">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Heading center={false} overline="Your Land, Your Home" title="A Property-Specific Approach" subtitle="Every lot is different. Before we promise what can be built, we evaluate your property so the design reflects the realities of your site." />
          <Bullets items={[
            "Lot evaluation and site considerations",
            "Access, utilities, and drainage review",
            "Topography, soil, and setbacks",
            "Clearing, grading, and site preparation",
            "Permitting and timeline considerations",
          ]} />
          <p className="text-[#a39d90] text-sm leading-relaxed mt-6">Note: not every lot is buildable as-is, and some sites require additional work. A property-specific evaluation is always required.</p>
        </div>
        <img src={IMAGES.realFraming} alt="Custom home being framed on the owner's lot in Central Florida" className="w-full h-[440px] object-cover border border-[#c9a24b]/20" loading="lazy" />
      </div>
    </Section>

    <CTASection title="Have a Lot? Let's Talk About Your Build" text="Tell us where your property is located and what you'd like to build. We'll help you understand the next steps for building on your lot." />
  </>
);

export default BuildOnYourLot;
